import { SDKUtils } from '@/imsdk/index';
// import { createAid, guid } from '@/imsdk/utils/aid.create';
import qs from 'qs';
import { cookie } from '@tencent/qd-lib';
import { myLocalStorage } from '@/utils/myLocalStorage';
import { isPrivate } from '@/utils/env';
import AUTH_TYPE, { AUTH_MIDDLE_PAGE } from '@/utils/authType';
import { replaceUrlQuery, addUrlQuery, removeUrlQuery } from '@/utils/urlTools';
import rumHelper from '@/utils/rumHelper';

// 本地存储的用户key
const saasAidLocalStorageKey = {
  aid: 'qdim_saas_user_id',
  d2: 'qdim_saas_token',
  uuid: 'qdim_saas_uuid',
};
// 存储 鉴权成功 后的数据。和匿名身份数据无关
const authDataKey = 'qdim_saas_auth_data';

export default {
  data() {
    return {
      hasLogined: false,
    };
  },
  computed: {
    // 需要将用户信息与kfuin进行绑定
    currentSaasAidLocalStorageKey() {
      return {
        aid: `${saasAidLocalStorageKey.aid}_${this.wpaDetail.kfuin}`,
        d2: `${saasAidLocalStorageKey.d2}_${this.wpaDetail.kfuin}`,
        uuid: `${saasAidLocalStorageKey.uuid}_${this.wpaDetail.kfuin}`,
      };
    },

    // 鉴权数据需要和kfuin绑定
    currentAuthDataKey() {
      return `${authDataKey}_${this.wpaDetail.kfuin}`;
    },
  },
  methods: {
    async createLoginConfig(maxReTryTime = 3) {
      const localStorageKey = this.currentSaasAidLocalStorageKey;
      // appId判断
      let appid;
      if (!isPrivate) {
        appid = 3; // sass版更改
      } else {
        appid = 3;
      };
      const kfuin = Number(this.wpaDetail.kfuin);

      // 注意 匿名模式和鉴权模式的区别：
      // 鉴权模式下，优先检查本地是否临时存储了d2等数据，如果有，那么就像匿名一样，发送aid+d2，且避免发送auth信息。
      // 如果本地没有临时缓存相关信息，才传入auth信息。
      // 匿名模式下，则检查本地是否有长期存储的d2等数据，然后发送。否则调用api生成新的身份。
      const { authRedirectUrl } = this.authConf;
      let { authType, authData } = this.authConf;
      const codeInAuthData = /code=[^&]+/.test(authData);

      // ------------ 从本地获取鉴权存储的信息 ------------
      // 匿名的想存储在localstorage中的，实名的是存在cookie中的，浏览器关闭后自动删除。
      let account;
      // 尝试读取已鉴权的用户信息
      const savedAuthAccount = this.authDataToStorage();
      // 尝试读取匿名的用户信息
      const savedAnonymousAccount = this.getAccount();
      // wx_mp鉴权的特殊处理：
      // why? —— 之前老webim部分访问，虽然url中包含了 auth=wx_mp， 但是没有带code，只是初始化jssdk，并不会走鉴权。
      // 而同时又因为，首次鉴权之后，会移除code。这种情况会和上面的情况混淆。
      // 所以，如果对于 auth=wx_mp，如果带code，那就走正常鉴权模式。
      // 如果发现没有带code，那就检测一下目前有没有存authAccount信息：
      // a. 如果有，说明是处于鉴权模式，此时应按照 实名鉴权方式 接入。
      // b. 如果没有，说明是匿名模式，应匿名接入。
      // 新增c. 如果 AUTH_TYPE[authType] 未配置，也应匿名接入。用来兜底部分企业配置参数错误的情况。
      const isFakeWxMpAuth = (authType === 'wx_mp' && !codeInAuthData && !this.isValidAccount(savedAuthAccount))
        || !AUTH_TYPE[authType];
      // 是假的鉴权，置控 authType。
      if (isFakeWxMpAuth) {
        authType = '';
        this.authConf = { ...this.authConf, authType };
      }

      // 之前留的坑。无用
      const canSkipAuth = false;
      if (authType && authType !== 'tencentSSO' && authType !== 'commonAuthCredential' && !canSkipAuth) {
        // 如果是鉴权模式，那么有些从临时存储中查找一下鉴权数据
        account = savedAuthAccount;
      } else {
        // 生成本地aid和uuid
        account = savedAnonymousAccount;
      }

      let hasCacheAccount = false;
      // 如果信息已经存在了，并且没有强制要求校验，就直接用这些信息去进线
      if (this.isValidAccount(account)) {
        console.log('[hasCacheAccount]', account);
        hasCacheAccount = true;
      }

      // ------------ 调用svr接口生成或验证aid+d2 -----------
      if (authType && authType !== 'tencentSSO' && authType !== 'commonAuthCredential' && !canSkipAuth) {
        // 需要鉴权
        // 准备一下鉴权参数
        const { ssoIframe, ssoIframeUrl, name: ssoName } = AUTH_TYPE[authType] || {};
        // 这里要替换一下auth的值。
        // 为什么？请查阅 authTypes.ts 中的说明。
        authData = replaceUrlQuery(authData, 'auth', ssoName);
        // 将wpaid放到authData中。因为url中的wpaid并不是标准化的。
        authData += `&wpa_id=${this.wpaDetail.wpaId}`;

        // 检查缓存的账号或者鉴权code。
        // 微信、企微ssc这些鉴权，一般是带了code才跳转到webim的。
        // 而且，即便没有带也前端不知道该跳转去哪里去获取，因此也就不检查了。
        // -------------------------------------------
        // 没读到缓存账号 && 需要跳转到第三方鉴权 && 还没code
        if (!hasCacheAccount && ssoIframe && !codeInAuthData) {
          // 没有code，需要获取
          if (ssoIframeUrl || authRedirectUrl) {
            // 如果是已经在前端代码中配置了跳转第三方的鉴权url(如广交会)，那么就直接跳转
            this.jumptoThirdSiteToAuth();
            return;
          }
        }
      }

      // 额外信息
      const extendData = qs.stringify({
        // 老webim特殊逻辑，会使用这个值当作vid。
        // 但新webim整体更新了业务逻辑，严谨如此操作。
        // 所以，目前仅会把这个值当作用户昵称显示。
        visitorId: this.wpaDetail.visitorId,
        nickName: this.wpaDetail.nickName,
        // 两会专用，前端透传，标识来源
        plat: this.wpaDetail.plat,
      });
      let loginConfig;
      // 验证匿名身份 或 生成鉴权身份。
      try {
        loginConfig = await SDKUtils.createVisitor(
          { appid, kfuin, userAgent: navigator?.userAgent, extendData },
          account,
          { authType, authData },
        );
      } catch (res) {
        // 登录失败是进行错误日志的上报
        window.QdMonitor  && window.QdMonitor.log({
          name: 'login_fail',
          ext1: JSON.stringify({
            appid, kfuin, ...account, ...{ authType, authData },
          }),
          ext2: JSON.stringify(res),
        });
        // 当官网鉴权的进入之后，直接进行aid和d2的进线
        // aid和d2进线失败之后，对外界进行告知，重新打开iframe重新进线
        // 原因是：由于aid本身与visitorId有很复杂的上报绑定关系，如果webIM在内部自己更新然后上报到外侧的时候
        // 会导致外侧的进线出现问题（wpa本身也需要建立sso链接从而保证代码的）
        if (this.inIframe && (authType === 'tencentSSO' || authType === 'commonAuthCredential')) {
          window.parent.postMessage({
            act: 'ERROR_AUTH',
            data: {
              visitorid: loginConfig.aid,
              token: loginConfig.d2,
              kfuin,
              wpaId: this.wpaDetail.wpaId,
              wpaKey: this.wpaDetail.key,
            },
          }, '*');
          return;
        }
        // 10017 d2失效
        // 60017 aid重复
        if (res.code === 10017 || res.code === 600017) {
          if (authType) {
            // TOFIX: 鉴权模式下会不会有这2个错误？如果有，该如何处理？
            // 先把临时缓存删除
            this.authDataToStorage(null);
            // 然后呢，报错？
            // 当为10017的时候，此时为有aid和d2但是d2已经失效过期了
            // 此时应该判断是否配置了跳转链接
            // 有跳转链接的时候就跳转到第三方的链接再此进线
            if (res.code === 10017 && (AUTH_TYPE[authType]?.ssoIframeUrl || authRedirectUrl)) {
            // 仅有跳转url配置时才跳转，否则仅抛出错误。
              this.jumptoThirdSiteToAuth();
              return;
            }
          } else {
            // 匿名登录的时候需要同步删除长期存储的aid和d2,
            this.clearAccount();
            // eslint-disable-next-line no-param-reassign
            maxReTryTime -= 1;
            // 每次请求有3次重试的机会
            if (maxReTryTime > 0) {
              return await this.createLoginConfig(maxReTryTime);
            }
          }
        } else if (res.code === 60000) {
          // 缓存到cache, 后续上报
          rumHelper.add({
            method: '[createLoginConfig-60000]',
            message: { authType, authData },
            url: location.href,
          });
          // 鉴权模式：鉴权出错，绕过鉴权。
          window.location.replace(location.href.replace(/auth=commonAuth/i, ''));
          return;
        } else if (res.code === 10018) {
          // // 通用鉴权code验证失败：此时应进行跳转，到第三方重新获取code
          // if (authType && (AUTH_TYPE[authType]?.ssoIframeUrl || authRedirectUrl)) {
          //   // 仅有跳转url配置时才跳转，否则仅抛出错误。
          //   this.jumptoThirdSiteToAuth();
          //   return;
          // }
          // // 失败后不做其他事情，仅抛出错误
          // --- 产品说 不跳转了，直接报错 ---
          // https://tapd.woa.com/TencentNewBiz/bugtrace/bugs/view?bug_id=1010109441110346233&jump_count=1
          // 所以什么也不做
        }

        // TOFIX: 显示错误。
        // this.$refs?.aio?.showTipMessage({ message: res.message });
        return Promise.resolve({ code: res.code, message: res.message });
      }

      // 请求成功删除tag.
      this.storeFetchCodeTimes('del');

      window.QdMonitor  && window.QdMonitor.log({
        name: 'login',
        ext1: JSON.stringify({
          appid, kfuin, ...account, ...{ authType, authData },
        }),
        ext2: JSON.stringify(loginConfig),
      });

      // 存储数据
      if (authType) {
        // 鉴权模式存储在临时存储中，和会话挂钩，页面关闭后消除
        if (!loginConfig.userInfo && savedAuthAccount.userInfo) {
          loginConfig.userInfo = savedAuthAccount.userInfo;
        }
        loginConfig.userInfo
          ? this.authDataToStorage({ aid: loginConfig.aid, d2: loginConfig.d2, userInfo: loginConfig.userInfo })
          : this.authDataToStorage({ aid: loginConfig.aid, d2: loginConfig.d2 });
      } else {
        if (this.inIframe) {
          // 此处通知更新WPA。
          window.parent.postMessage({
            act: 'UPDATE_AUTH',
            data: {
              visitorid: loginConfig.aid,
              token: loginConfig.d2,
              kfuin,
              wpaId: this.wpaDetail.wpaId,
            },
          }, '*');
        } else {
          // 此处对匿名情况下的数据进行保存
          try {
            loginConfig.aid
              ? myLocalStorage.setItem(localStorageKey.aid, loginConfig.aid)
              : myLocalStorage.removeItem(localStorageKey.aid);
            loginConfig.d2
              ? myLocalStorage.setItem(localStorageKey.d2, loginConfig.d2)
              : myLocalStorage.removeItem(localStorageKey.d2);
          } catch (error) {
            console.log('防止无痕模式iframe中的localStorage报错', error);
          }
        }
      }

      return { ...loginConfig, appid };
    },

    // 清除本地用户信息
    clearAccount() {
      if (this.inIframe) {
        this.wpaDetail.visitorid = '';
        this.wpaDetail.uuid = '';
        this.wpaDetail.token = '';
      } else {
        const localStorageKey = this.currentSaasAidLocalStorageKey;
        try {
          Object.values(localStorageKey).forEach((key) => {
            myLocalStorage.removeItem(key);
          });
        } catch (ex) {}
      }
    },

    // 获取当前的用户信息
    getAccount() {
      let account = {};
      if (this.inIframe) {
        account = {
          aid: this.wpaDetail.visitorid,
          uuid: this.wpaDetail.uuid,
          d2: this.wpaDetail.token,
        };
      } else {
        const localStorageKey = this.currentSaasAidLocalStorageKey;
        try {
          // 后端目前不支持多个主号同一个aid的情况报60017，先回到之前的逻辑 由于会出现不同主号之前aid相同会互踢，回到之前的逻辑
          // if (!myLocalStorage.getItem(localStorageKey.aid) && this.getTenecntSig() && !this.hasLogined) {
          //   account.aid = this.getTenecntSig();
          //   account.uuid = myLocalStorage.getItem(account.aid) ? myLocalStorage.getItem(account.aid) : guid();
          //   account.d2 = '';
          // } else {
          account.aid =  myLocalStorage.getItem(localStorageKey.aid) || '';
          account.d2 = myLocalStorage.getItem(localStorageKey.d2) || '';
          account.uuid = myLocalStorage.getItem(localStorageKey.uuid) || '';
          // }
        } catch (ex) {
          account.aid = '';
          account.d2 = '';
          account.uuid = '';
        }
      }
      // 新增逻辑判断，首次进线的时候保存aid和uuid的关系，因为首次进线成功之后tencentSig会和aid的值保持一致
      // if (!account.aid) {
      //   account.aid = createAid();
      //   account.uuid = guid();
      //   account.d2 = '';
      // }
      // account.aid && account.uuid && myLocalStorage.setItem(account.aid, account.uuid);
      this.hasLogined = true;
      return account;
    },

    getTenecntSig() {
      try {
        //  URL 优先级第一 cookie优先级第二，兼容旧版本
        //  和之前老的webIM保持获取tencentSig的方式一致
        const key = 'tencentSig';
        const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        let visitorId = params.visitorId ? params.visitorId :  cookie.get(key);
        if (!/^\d+$/.test(visitorId)) {
          visitorId = '';
        };
        if (!visitorId) {
          visitorId = localStorage.getItem(key);
        };
        return visitorId ? visitorId : '';
      } catch (ex) {
        return '';
      }
    },

    /**
     * 从临时Storage中读取鉴权返回的aid+d2，或将数据存储。
     */
    authDataToStorage(data) {
      const key = this.currentAuthDataKey;
      if (data) {
        // 微信内置H5有bug，会话级cookie不会自动被清除，因此改为sessionStorage
        try {
          sessionStorage.setItem(key, JSON.stringify(data));
        } catch (ex) { }
      } else if (data === null) {
        try {
          sessionStorage.removeItem(key);
        } catch (ex) { }
      } else {
        try {
          return JSON.parse(sessionStorage.getItem(key) || '{}');
        } catch (ex) {
          return {};
        }
      }
    },

    /**
     * sso鉴权跳转第三方获取code逻辑
     */
    jumptoThirdSiteToAuth() {
      if (this.inIframe) {
        // TODO: iframe中的鉴权处理逻辑
        return;
      }

      // 如果已经超过最大重试次数，就停止。
      if (this.storeFetchCodeTimes('retry') === false) {
        this.$refs?.aio?.showIncomingTimeout();
        return;
      }

      const { authType, authRedirectUrl } = this.authConf;
      const { authDomain, ssoIframeUrl } = AUTH_TYPE[authType];

      let commonAuthRedirectUrl;
      if (authRedirectUrl) {
        commonAuthRedirectUrl = addUrlQuery(authRedirectUrl, 'redirect_uri', AUTH_MIDDLE_PAGE);
      }

      // 三方鉴权跳转地址。由外部传入的跳转地址，或者根据authType获取代码中写死的跳转地址。
      const thirdAuthUrl = commonAuthRedirectUrl || `https://${authDomain}${ssoIframeUrl}`;
      let currentUrl = window.location.href;
      // 拼接新的跳转url：第三方跳转地址+我方回跳地址。
      // href有时会出现移除code失败的情况，此时应该在进行跳转的时候再次进行处理
      currentUrl = removeUrlQuery(currentUrl, 'code');
      currentUrl = removeUrlQuery(currentUrl, 'response_type');
      currentUrl = removeUrlQuery(currentUrl, 'session_state');
      currentUrl = removeUrlQuery(currentUrl, 'scope');
      currentUrl = removeUrlQuery(currentUrl, 'nonce');
      currentUrl = removeUrlQuery(currentUrl, 'msgInfo');
      const redirectUrl = thirdAuthUrl + encodeURIComponent(`?queryString=${encodeURIComponent(currentUrl)}`);

      // // 存储跳转链接。
      // // 为什么？——暂不清楚。老webim中会缓存该值，然后拿到code进行验证的时候将该值传入。
      // // 似乎是进行合法性校验？？？
      // // 先把这个逻辑屏蔽了
      // myLocalStorage.setItem('CURRENT_REDIRECT_URL', `${redirectUrl}?queryString=${url}`);

      // 缓存到cache, 后续上报
      // 注意，因为第三方可能要登录，所以这里缓存的时间长一些
      rumHelper.add({
        method: '[jumptoThirdSiteToAuth]',
        message: { authType, redirectUrl },
        url: location.href,
      }, 60 * 1000);

      window.location.replace(redirectUrl);
    },

    /**
     * 处理进线时的错误
     */
    hanldErrorForD2(error) {
      console.log('[hanldErrorForD2]', error);
      // 下方逻辑目前不需要了。

      // // 命中以上错误时，要根据当前情况进线处理。
      // const { authType } = this.authConf;
      // if (authType) {
      //   // 实名鉴权
      //   // 如果是鉴权型接待报错了，那么就移除cookie中存储的aid+d2s数据。
      //   this.authDataToStorage(null);
      // } else {
      //   // 匿名
      //   this.clearAccount();
      // }

      // // 重新 鉴权、登录、进线。注意，此方法定义在MixinUi.js中
      // this.checkAccountAndLongin(true);
    },

    /**
     * 纪录或删除跳转第三方获取code的次数
     * @param {*} action 动作，'retry' 或 'del';
     * @returns
     */
    storeFetchCodeTimes(action) {
      const MAX_RETRY_TIMES = 2;
      const { kfuin, wpaId } = this.wpaDetail;
      const key = `qdim_fetch_code_times_${kfuin}_${wpaId}`;
      try {
        if (action === 'retry') {
          let count = sessionStorage.getItem(key) || 0;
          count = count - 0 + 1;
          sessionStorage.setItem(key, count);
          if (count > MAX_RETRY_TIMES) {
            // 超过重试次数时，要在返回false的同时清空这个值，这样才能在用户主动刷新的时候重新重试。
            sessionStorage.removeItem(key);
            return false;
          }
          return true;
        } if (action === 'del') {
          sessionStorage.removeItem(key);
        }
      } catch (ex) {
        // 如果 myLocalStorage 操作失败（被禁用），那么就直接返回false。
        return false;
      }
    },

    /**
     * 检测是否是一个有效的账户信息
     * @param {*} account
     */
    isValidAccount(account) {
      return !!(account && account.aid && account.d2);
    },
  },
};
